import { useEffect, useState } from "react";
import { api } from "../../../shared/api/client";
import { Empty, Loading } from "../../../shared/components/Empty";
import { Pill } from "../../../shared/components/Pill";

type Log = {
  id: number; user_id: number | null; user_email: string | null;
  action: string; request_method: string | null; request_path: string | null;
  ip_address: string | null; status_code: number | null; result: string | null;
  created_at: string;
};

export function AdminAudit() {
  const [items, setItems] = useState<Log[] | null>(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    const p = new URLSearchParams();
    if (q) p.set("action", q);
    p.set("size", "100");
    api.get<{ data: Log[] }>(`/admin/audit-logs?${p}`).then((r) => setItems(r.data.data));
  }, [q]);
  return (
    <div className="t-grid cols-1">
      <div className="t-card">
        <input className="t-input" placeholder="액션 필터…" value={q} onChange={(e) => setQ(e.target.value)} style={{ maxWidth: 400 }}/>
      </div>
      {items === null && <Loading/>}
      {items?.length === 0 && <Empty msg="로그가 없습니다"/>}
      <div className="t-card" style={{ padding: 0 }}>
        <div className="t-list" style={{ padding: 16 }}>
          {items?.map((l) => (
            <div key={l.id} className="t-row">
              <span className="meta" style={{ width: 150 }}>{new Date(l.created_at).toLocaleString("ko-KR")}</span>
              <span className="meta" style={{ width: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l.user_email ?? "system"}</span>
              <span className="mono" style={{ fontSize: 11, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l.action}</span>
              <span className="mono" style={{ fontSize: 11, color: "var(--text-3)" }}>{l.ip_address}</span>
              <Pill kind={l.result === "SUCCESS" ? "ok" : "danger"}>{l.status_code}</Pill>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
